import { connect } from 'react-redux'
import Dates from './Dates'

const DatesComponent = connect(({
  form: {
    searchFilters,
  },
}) => ({
  searchFilters,
}))(Dates)

DatesComponent.propTypes = Dates.propTypes;

export default DatesComponent;
